import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import Hidden from '@material-ui/core/Hidden'

// import {Link} from 'react-router-dom';

import phone from '../../../assets/illustrations/phone.svg'
import band from '../../../assets/illustrations/band.svg'
import selfie from '../../../assets/illustrations/selfie.svg'
import beer from '../../../assets/illustrations/beer.svg'

// DOTS
import dot1 from '../../../assets/Dots/1.svg'
import dot2 from '../../../assets/Dots/2.svg'
import dot3 from '../../../assets/Dots/3.svg'

export default class SkewBg extends React.Component{

  render(){
    return(
    	<div>
         <Hidden smDown>
            <img className={css(styles.dot1)} src={dot1} alt=""/>
            <img className={css(styles.dot15)} src={dot1} alt=""/>
            <img className={css(styles.dot2)} src={dot2} alt=""/>
            <img className={css(styles.dot25)} src={dot2} alt=""/>
            <img className={css(styles.dot3)} src={dot3} alt=""/>
            <img className={css(styles.dot4)} src={dot3} alt=""/>
            <img className={css(styles.dot5)} src={dot3} alt=""/>
        </Hidden>
            <section className={css(styles.skewIntro)}>
                <div className={css(styles.spanOverlay)}></div>
                <div className={css(styles.spanOverlayBottom)}></div>
            </section>
            <Hidden smDown>
                <section className={css(styles.objectsIllustration)}>
                    <div >
                        <img className={css(styles.phone, styles.objectSingle)} src={phone} alt=""/>
                    </div>
                    <div >
                        <img className={css(styles.band, styles.objectSingle)} src={band} alt=""/>
                    </div>
                    <div >
                        <img className={css(styles.selfieStand, styles.objectSingle)} src={selfie} alt=""/>
                    </div>
                    <div >
                        <img className={css(styles.beerBarrel, styles.objectSingle)} src={beer} alt=""/>
                    </div>
                </section>
            </Hidden>
    	</div>
    )
  }
}
// const translateKeyframes = {
//     '0%': {
//         transform: 'translateX(-100px)',
//         opacity: 0,
//     },'20%': {
//         transform: 'translateX(-100px)',
//         opacity: .2,
//     },'50%': {
//         transform: 'translateX(40vw)',
//         opacity: .6,
//     },'100%': {
//         transform: 'translateX(120vw)',
//          opacity: 1,
//     },
// }
// const opacityKeyframes = {
//     '0%': {
//         opacity: .3,
//     },
//     '50%': {
//         opacity: .8,
//     },'80%': {
//         opacity: .6,
//     },
//     '100%': {
//         opacity: .3,
//     }
// };

const styles = StyleSheet.create({
    dot1 : {
        position: 'absolute',
        bottom: '10%',
        left: '10%',
        width: '2em',
    }, dot15 : {
        position: 'absolute',
        top: '10%',
        left: '10%',
        width: '1.2em',
    },    dot2 : {
        position: 'absolute',
        top: '25%',
        left: '35%',
        width: '1.9em',
        opacity: .45
    },    dot3 : {
        position: 'absolute',
        bottom: '4%',
        left: '45%',
        width: '21em',
    },    dot25 : {
        position: 'absolute',
        top: '35%',
        right: '45%',
        width: '1.2em',
    },  dot4 : {
        position: 'absolute',
        top: '50%',
        left: '20%',
        width: '10em',
        opacity: .4
    },  dot5 : {
        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '10em',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: '0',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        transform: 'skewY(-12deg)',
        transformOrigin: 0,
        background: 'linear-gradient(-69deg, #4D88FF, #457FDD)',
    },
    spanOverlay: {
        position: 'absolute',
        top: -50,
        left: 422,
        width: 1000,
        zIndex:1,
        height: 370,
        background: 'linear-gradient(90deg, rgb(0,0,0,0), rgb(0,0,0,.1), rgb(0,0,0,0))',
        // animationName: [opacityKeyframes],
        // animationDuration: '7s',
        // opacity: .3,
        // animationDelay: '2s',
        // animationIterationCount: 'infinite'
    },
    spanOverlayBottom: {
        position: 'absolute',
        bottom: -50,
        left: 40,
        width: 600,
        height: 170,
        background: 'linear-gradient(90deg, rgb(0,0,0,0), rgb(0,0,0,.2), rgb(0,0,0,0))',
        opacity: .3,
        // animationName: [translateKeyframes],
        // animationDuration: '7s',
        // animationDelay: '2s',
        // animationIterationCount: 'infinite'
    },
    objectsIllustration: {
        pointerEvents: 'none',
        position: 'absolute',
        display: 'flex',
        top: 64,
        marginLeft: 0,
        left: 'calc(50% - -66px)',
        transform: 'scale(.95) rotate(-12deg)',
        width: '829px',
        height: 1500,
        zIndex: 3,
    },
    objectSingle: {
            filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
        },
    phone: {
        width: 200,
        height: 'auto',
        position: 'absolute',
        top: 186
    },
    band: {
        height: 'auto',
        position: 'absolute',
        top: 56,
        left: 220,
        width: 249,
    },
    selfieStand: {
        height: 'auto',
        position: 'absolute',
        top: 336,
        left: 219,
        width: 275,
    },
    beerBarrel: {
        height: 'auto',
        position: 'absolute',
        top: 16,
        left: 520,
        width: 189,
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/Intro/SkewBg.js